<i18n>
{
	"en": {
		"label": "Broadcast to drivers",
		"placeholder": "Choose drivers",
		"driverNotContactable": "One or more driver is missing contact info"
	},
	"no": {
		"label": "Kringkast til sjåfører",
		"placeholder": "Velg sjåfører",
		"driverNotContactable": "En eller flere sjåfører mangler kontaktinfo"
	}
}
</i18n>

<template>
	<t-multiselect
		ref="input"
		:label="$t('label')"
		:allItems="drivers"
		:selectedItems="selectedItems"
		:isInvalid="Boolean(firstErrorFound)"
		:validationMessage="$t(firstErrorFound)"
		:placeholder="$t('placeholder')"
		:itemKeys="['name', 'phoneNumber', 'email']"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
import { mapState } from '@/modules/drivers/store/drivers.store.js';
import TMultiselect from '@/components/evergreen/timpex/inputs/TMultiselect';

export default {
	name: 'BroadcastDriversInput',
	components: { TMultiselect },
	props: {
		selectedItems: Array,
		errors: Array,
	},

	computed: {
		...mapState(['drivers']),
		firstErrorFound() {
			return this.errors.reduce((acc, err) => acc || err, false) || '';
		}
	},
};
</script>
